define( 'auth-media-gateway/subclasses/MediaFrameworkResponseHelper',['require','exports','module','auth-media-gateway/subclasses/Utils'],function( require, exports, module ) {

    var Utils = require('auth-media-gateway/subclasses/Utils');
    var _ensureArray = function(obj) {
        return (obj instanceof Array) ? obj : (typeof obj !== 'undefined') ? [obj] : [];
    };

    function MediaFrameworkResponseHelper(mediaFrameworkResponse){

        var _this = this;
        this.mediaResponse = mediaFrameworkResponse;


        /**
         * This method will return true if at least one media item of the requested type
         * is free (or, other words, does not require authorization)
         *
         */
        this.isFree = function (mediaItemType)
        {
            if ( typeof mediaItemType === "undefined" || mediaItemType === null || mediaItemType === "" ){
                mediaItemType = "video";
            }
            var isFree = false;
            var contentItems = _ensureArray(this.mediaResponse.user_verified_event.user_verified_content);

            if (!!contentItems && contentItems.length>0) {
                var tmpContentItem,
                    media_item,
                    features;

                for (j in contentItems) {
                    tmpContentItem = contentItems[j];
                    if ( !!tmpContentItem ) {
                        if (tmpContentItem.type === mediaItemType) {
                            var featuresVO = tmpContentItem.features;
                            if (typeof featuresVO !== "undefined" && featuresVO != null) {
                                if (typeof featuresVO.feature !== "undefined" && featuresVO.feature != null) {
                                    features = _ensureArray(featuresVO.feature);

                                    for (var feature in features) {
                                        if (feature === MediaFrameworkResponseHelper.FREE_GAME || feature === MediaFrameworkResponseHelper.FREE_EVENT)
                                        {
                                            isFree = true;
                                            break;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

            return isFree;
        }

        /***
         * This method will return true if the user is authorized to view at least one
         * media item within the list.
         */
        this.isAuthorized = function (mediaItemType)
        {
            if ( typeof mediaItemType === "undefined" || mediaItemType === null || mediaItemType === "" ){
                mediaItemType = "video";
            }

            var isAuthorized = false;
            var authStatus;

            var contentItems = _ensureArray(this.mediaResponse.user_verified_event.user_verified_content);

            if (!!contentItems && contentItems.length>0) {
                var tmpContentItem,
                    media_item;

                for (j in contentItems) {
                    tmpContentItem = contentItems[j];
                    if ( !!tmpContentItem ) {
                        media_item = ($.isArray(tmpContentItem.user_verified_media_item)) ? tmpContentItem.user_verified_media_item[0] : tmpContentItem.user_verified_media_item;

                        //get the auth status, which is the object name inside the auth status object
                        //if(content.type == mediaItemType)
                        //{
                        for (authStatus in media_item.auth_status){
                            if (authStatus === "successStatus")
                            {
                                isAuthorized = true;
                                break;
                            }
                        }
                        //}
                    }
                }
            }

            return isAuthorized;
        }

        /***
         * This method will return true if the user is authorized to view at least one
         * media item within the list.
         */
        this.isLoginRequired = function (mediaItemType)
        {
            if ( typeof mediaItemType === "undefined" || mediaItemType === null || mediaItemType === "" ){
                mediaItemType = "video";
            }

            var isLoginRequired = true;
            var authStatus;

            var contentItems = _ensureArray(this.mediaResponse.user_verified_event.user_verified_content);

            if (!!contentItems && contentItems.length>0) {
                var tmpContentItem,
                    media_item;

                for (j in contentItems) {
                    tmpContentItem = contentItems[j];
                    if ( !!tmpContentItem ) {
                        media_item = ($.isArray(tmpContentItem.user_verified_media_item)) ? tmpContentItem.user_verified_media_item[0] : tmpContentItem.user_verified_media_item;

                        //get the auth status, which is the object name inside the auth status object
                        //if(content.type == mediaItemType)
                        //{
                        for (authStatus in media_item.auth_status){
                            if (authStatus !== "loginRequiredStatus")
                            {
                                isLoginRequired = false;
                                break;
                            }
                        }
                        //}
                    }
                }
            }

            return isLoginRequired;
        }

        this.isVideoBlackedOut = function (blackoutStatusToEvaluate){
            return (blackoutStatusToEvaluate !== "none" && blackoutStatusToEvaluate !== "unknown");
        }

        /**
         * This returns the blackout status of the media items.
         *
         * This will only return a blackout status if all media items within the response
         * have a blackedout status.  If at least one media item of the requested media type
         * is not blacked out, then this method will return null.
         *
         */
        this.getBlackoutStatus = function (considerAudioContentBlackoutStatus, modelBlackOutStatus)
        {
            if ( considerAudioContentBlackoutStatus !== true ){
                considerAudioContentBlackoutStatus = false;
            }
            if ( typeof modelBlackOutStatus === "undefined" || modelBlackOutStatus === null ){
                modelBlackOutStatus = null;
            }

            var blackoutStatus = null;

            var contentItems = _ensureArray(this.mediaResponse.user_verified_event.user_verified_content);

            if (!!contentItems && contentItems.length>0) {
                var tmpContentItem,
                    media_item;

                for (j in contentItems) {
                    tmpContentItem = contentItems[j];
                    if ( !!tmpContentItem ) {


                        if ( tmpContentItem.type === "audio" && considerAudioContentBlackoutStatus===false ){
                            //if(blackoutStatus===null && !!modelBlackOutStatus){
                            //	blackoutStatus = modelBlackOutStatus;
                            //}
                            continue;
                        } else{
                            media_item = ($.isArray(tmpContentItem.user_verified_media_item)) ? tmpContentItem.user_verified_media_item[0] : tmpContentItem.user_verified_media_item;

                            //get the blackout status, which is the object name inside the blackout status object
                            for (blackoutStatus in media_item.blackout_status){
                                if ( blackoutStatus === "none" || blackoutStatus === "successStatus" ){
                                    Utils.log("MediaFrameworkResponseHelper getBlackoutStatus: contentItem["+j+"].blackoutStatus = "+blackoutStatus+" so return 'none'");
                                    return "none";
                                }
                            }
                        }
                    }
                }
            }

            Utils.log("MediaFrameworkResponseHelper getBlackoutStatus: blackoutStatus = "+blackoutStatus);

            /*
            if(!blackoutStatus  ||  (blackoutStatus.blackedOutStatus.length == 0 && !blackoutStatus.status )){
                blackoutStatus = new BlackoutStatus();
                if(modelBlackOutStatus){
                    blackoutStatus.blackedOutStatus.push(modelBlackOutStatus );
                } else {
                    blackoutStatus.status = BlackoutStatus.UNKNOWN ;
                }
            }
            var status = blackoutStatus.getStatus();
            return status;
            */


            if ( blackoutStatus===null ){
                if(!!modelBlackOutStatus){
                    blackoutStatus = modelBlackOutStatus;
                } else {
                    blackoutStatus = "unknown";
                }
            }

            Utils.log("MediaFrameworkResponseHelper getBlackoutStatus: return blackoutStatus = "+blackoutStatus);

            return blackoutStatus;
        }
    }

    MediaFrameworkResponseHelper.prototype = {
        mediaResponse : null
    }

    MediaFrameworkResponseHelper.getDomainAttributesObject = function(contentItem)
    {
        var domainAttrObject = {};

        try {
            var i, domainAttr = [];
            var domainSpecificAttributes = contentItem.domain_specific_attributes;
            if (typeof domainSpecificAttributes !== "undefined" && domainSpecificAttributes != null) {
                if (typeof domainSpecificAttributes.domain_attribute !== "undefined" && domainSpecificAttributes.domain_attribute != null) {
                    domainAttr = _ensureArray(domainSpecificAttributes.domain_attribute);

                    var name, value;
                    for (i in domainAttr){
                        name = domainAttr[i].name;
                        value = domainAttr[i].value;

                        if ( typeof domainAttrObject[name] === "undefined" || domainAttrObject[name] === null )
                        {
                            // First value to populate for this key/value pair
                            domainAttrObject[name] = value;
                        }
                        else if ( domainAttrObject[name] instanceof Array )
                        {
                            // Add the value to the list of values for this key
                            domainAttrObject[name].push(value);
                        }
                        else
                        {
                            // A value already exists for this key, so make it an array
                            var existingValue = domainAttrObject[name];
                            domainAttrObject[name] = [ existingValue, value ];
                        }
                    }
                }
            }
        } catch (error) {
            Utils.log("MediaFrameworkResponseHelper getDomainAttributesObject: error analyzing domain_specific_attributes");
        }

        return domainAttrObject;
    }


    MediaFrameworkResponseHelper.FREE_GAME = "mp4.freeGame";
    MediaFrameworkResponseHelper.FREE_EVENT = "mp4.freeEvent";

    return MediaFrameworkResponseHelper;
});

